import React from 'react';
import Slider from 'react-slick';
import { ProjectsListAR } from './projectsData.js'; // Import your service data
import { ProjectsListEN } from './projectsData.js'; // Import your service data
import OurProjects from './ourproject.js'; // Import your ServiceCard component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLanguage } from '../context/LanguageContext.js';
 const ProjectsSliders =()=> {
  const {language} = useLanguage();
  const ProjectsList=language==="en"?ProjectsListEN:ProjectsListAR;
// Slider settings
const settings = {
    dots: true, // Show dots
    infinite: true, // Infinite loop
    speed: 500, // Transition speed
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    // arrows: false,
    autoplay: true, // Auto-play the slider
    autoplaySpeed: 2000, // Auto-play speed
    responsive: [
      {
        breakpoint: 768,  // Mobile breakpoint (adjust as needed)
        settings: {
          slidesToShow: 2,  // Show 1 slide on mobile
          slidesToScroll: 1,
          dots: true,      // Keep dots for mobile if needed
        },
      },
      {
        breakpoint: 430,  // Mobile breakpoint (e.g., iPhone 13/14)
        settings: {
          slidesToShow: 1,  // 1 slide for small devices
          slidesToScroll: 1,
          dots: true,      // Optional: Hide dots if needed
          arrows: false,   // Optional: Hide arrows for mobile
        },
      },
    ],
    
    
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
      {ProjectsList.map((project) => {
 
  return (
    <div key={project.id}>
      <OurProjects data={project} />
    </div>
  );
})}
      </Slider>
    </div>
  );


   
};
export default ProjectsSliders;